module.exports = __webpack_public_path__ + "static/redime-tus-puntos-1-2c7374c444e733150d411c795e33368d.png";